import { faBan, faCheck, faEdit, faFile, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import BsButton from '../../collection/bootstrap/BsButton';
import DataTable from '../../collection/DataTable';
import TableHandler from '../../collection/TableHandler';
import ValidacionFilter from '../../components/filters/ValidacionFilter';
import SolicitudVestimenta from '../../components/modals/SolicitudVestimentaModal';
import EpiBoolean from '../../components/project/EpiBoolean';
import FloatingAddButton from '../../components/project/FloatingAddButton';
import Validado from '../../components/project/Validado';
import { apiDelete, apiForm, apiGet, apiUrl, apiBlobForm, getSession } from '../../utils/api';
import { generateFormData, sortableString } from '../../utils/functions';

export default function SolicitudesVestimenta(props) {
    // default filter
    const usuario = getSession();
    const defaultFilter = {
        trabajador: props.super ? null : usuario.id,
        pendiente: props.super ? true : null,
        validado: props.super ? null : true
    };
    let filter = generateFormData(defaultFilter);
    // show excel button
    const [showExcelButton, setShowExcelButton] = useState(false);
    const [excelFilter, setExcelFilter] = useState(filter);

    // api calls
    const updateData = async newFilter => {
        filter = newFilter ? newFilter : filter;
        newFilter ? setShowExcelButton(true) : setShowExcelButton(false);
        setExcelFilter(filter);
        return await apiForm("vestuario/table", filter);
    }
    const deleteRow = async id => await apiDelete("vestuario/delete/" + id);
    const performAction = async (action, id) => await apiGet(`vestuario/${action}/${id}`);
    const downloadExcel = async () => {
        const blob = await apiBlobForm("vestuario/excel", excelFilter);
        const url = window.URL.createObjectURL(blob);

        // download file
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'SolicitudesVestimenta.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    // render
    return <>
        <h2>{`${props.super ? "Validar solicitudes de" : "Solicitar"} vestimenta`}</h2>
        <TableHandler
            onUpdate={updateData}
            onDelete={deleteRow}
            onAction={performAction}
            elementText="la solicitud">
            <ValidacionFilter
                className="my-3" fem
                defaultValue={defaultFilter}
                selectTrabajador={props.super}
                selectVestimenta
                selectEstado />
            {usuario.permisoVestuario && showExcelButton && <BsButton className="mb-2" onClick={downloadExcel}>Descargar Excel</BsButton>}
            <SolicitudesTable
                super={props.super} />
        </TableHandler>
    </>;
}

function SolicitudesTable(props) {
    // table columns
    const columns = [
        {
            name: "Trabajador",
            selector: row => sortableString(row.NombreTrabajador),
            format: row => row.NombreTrabajador,
            sortable: true,
            omit: !props.super
        },
        {
            name: "Última modificación",
            selector: row => moment(row.FechaHora).format("YYYY-MM-DD HH:mm"),
            format: row => moment(row.FechaHora).format("DD/MM/YY HH:mm"),
            sortable: true
        },
        {
            name: "Prenda",
            selector: row => row["epi"] + sortableString(row.Prenda),
            format: row => <span title={row.Prenda}><EpiBoolean value={row.EPI} size="lg" /> {row.Prenda}</span>,
            sortable: true,
        },
        {
            name: "Talla",
            selector: row => sortableString(row.Talla),
            format: row => row.Talla,
            sortable: true,
        },
        {
            name: "Motivo",
            selector: row => sortableString(row.Motivo),
            format: row => row.Motivo,
            sortable: true,
        },
        {
            name: "Validado en",
            selector: row => moment(row.FechaHoraValidacion).format("YYYY-MM-DD HH:mm"),
            format: row => row.FechaHoraValidacion ? moment(row.FechaHoraValidacion).format("DD/MM/YY HH:mm") : "No validado",
            sortable: true
        },
        {
            name: "Validado",
            selector: row => row.Pendiente ? 0 : row.Validado ? 1 : 2,
            format: row => <Validado pendiente={row.Pendiente} validado={row.Validado} sufix="a" size="lg" />,
            sortable: true,
            center: true
        }
    ];

    // table buttons
    const buttons = row => {
        const viewBtn = <a href={apiUrl("vestuario/imagen/" + row.Id)} target="_blank"><Button variant="primary" size="sm"><FontAwesomeIcon icon={faFile} /></Button></a>;
        const viewBtnOutlined = <a href={apiUrl("vestuario/imagen/" + row.Id)} target="_blank" > <Button variant="outline-primary" size="sm"><FontAwesomeIcon icon={faFile} /></Button></a>;
        return <>
            {props.super ?
                (row.Pendiente ?
                    <>
                        {/* super && pendiente */}
                        {row.Imagen && viewBtn}
                        <Button title="Aprobar" action="validate" variant="success" size="sm" onClick={props.onAction}><FontAwesomeIcon icon={faCheck} /></Button>
                        <Button title="Denegar" action="invalidate" variant="danger" size="sm" onClick={props.onAction}><FontAwesomeIcon icon={faTimes} /></Button>
                    </> :
                    (row.Validado ? <>
                        {/* super && !pendiente && validado */}
                        {row.Imagen && viewBtn}
                        <Button title="Cancelar" action="cancel" variant="outline-danger" size="sm" onClick={props.onAction}><FontAwesomeIcon icon={faBan} /></Button>
                    </> : <>
                        {/* super && !pendiente && !validado */}
                        {row.Imagen && viewBtnOutlined}
                    </>)
                ) :
                (row.Pendiente ?
                    <>
                        {/* !super && pendiente */}
                        {row.Imagen && viewBtn}
                        <Button variant="secondary" size="sm" onClick={props.onEdit}><FontAwesomeIcon icon={faEdit} /></Button>
                        <Button variant="danger" size="sm" onClick={props.onDelete}><FontAwesomeIcon icon={faTrash} /></Button>
                    </> : (row.Validado ? <>
                        {/* !super && !pendiente && validado */}
                        {row.Imagen && viewBtn}
                    </> : <>
                        {/* !super && !pendiente && !validado */}
                        {row.Imagen && viewBtnOutlined}
                    </>)
                )
            }</>;
    };
    const name = row => (props.super ? `${row.NombreTrabajador}, ` : "") + `${row.Prenda} por ${row.Motivo}`;

    // render
    return <>
        <DataTable responsive rowname={name} buttons={buttons} columns={columns} data={props.data} pagination />
        {props.formOpen && (
            <SolicitudVestimenta
                show={props.formOpen}
                onHide={props.onFormClose}
                idSolicitudVestimenta={props.formId}
            />
        )}
        {!props.super && <FloatingAddButton onClick={props.onNew} />}
    </>;
}
